import React from 'react';
import { OfferLookupDto } from '../../../api-service/clients';
import { formatDate } from '../../../utilities';

export function formatOffer(offer?: OfferLookupDto) {
  if (!offer || !offer.offerId) return '';
  return offer.companyName ? `${getBaseTitle(offer)} - ${offer.companyName}` : getBaseTitle(offer);
}

export function renderOffer(props: object, offer?: OfferLookupDto) {
  return (
    <li {...props} key={offer?.offerId}>
      <div>
        <div> {getBaseTitle(offer)}</div>
        <div>{offer?.companyName}</div>
      </div>
    </li>
  );
}
function getBaseTitle(offer?: OfferLookupDto) {
  if (!offer || !offer.offerId) return '';
  const date = offer.startDate && offer.endDate ? `- (${formatDate(offer.startDate)} - ${formatDate(offer.endDate)})` : '';
  return `${offer.title} ${date} - ${offer.category?.description}`;
}
